import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const DropIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Path
        d="M18.1435 7.21283C17.972 6.93199 17.567 6.92951 17.388 7.20288C15.5266 10.0584 9.41038 15.4489 9.03263 20.4194C8.59025 26.2225 12.7058 29.2843 17.7707 29.2843C22.8357 29.2843 26.7624 25.4148 26.3821 20.3573C26.0044 15.3222 19.9926 10.2051 18.146 7.21283H18.1435Z"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

DropIcon.displayName = "DropIcon";
export { DropIcon };
